import VacationUser from 'features/vacations/vacationUser';
import { useTitle } from '../helpers';

/**
 * @page UserPage
 */

const VacationsUserPage = () => {
  useTitle('Информация о заявлении');

  return (
    <>
      <h3>Информация о заявлении</h3>
      <VacationUser />
    </>
  );
};

export default VacationsUserPage;
